var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('div',{ref:"sliderWrapper",staticClass:"slider-wrapper"},[_c('div',{ref:"sliderContent",staticClass:"slider-content",style:({ transform: `translateX(-${_vm.currentIndex * _vm.itemWidth}px)` })},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }